export default function loadLocale(locale) {
      return locale==='en'||
locale==='en-US'? import(/* webpackChunkName: "en-US" */'./en-US'):null;
}
